import type {Ability} from '../../../../generated/types';
import type {FeatureData, OriginData, OriginToolChoice} from './catalog';
import type {ChooseGroup} from './types';

const TOOL_CHOICE_LABELS: Record<OriginToolChoice, string> = {
	tool: 'Инструменты ремесленника',
	instrument: 'Музыкальный инструмент',
	gamingSet: 'Игровой набор',
};

export function createOriginFeature(origin: OriginData): FeatureData {
	return {
		id: `origin-${origin.id}`,
		title: origin.title,
		description: '',
		levels: [1],
		order: 0,
		props: {
			skillProficiencies: origin.skills,
			toolsProficiencies: origin.toolId ? [origin.toolId] : undefined,
		},
		choose: [
			abilityIncreaseGroup(origin.abilities),
			...(origin.toolChoice ? [toolGroup(origin.toolChoice)] : []),
			...(origin.featId || origin.featCategory ? [featGroup(origin)] : []),
		],
	};
}

const abilityGroup = (abilities: Ability[], increase: number): ChooseGroup => ({
	key: 'origin-ability',
	type: 'ability',
	label: `Характеристика +${increase}`,
	options: abilities.map((ability) => ({key: ability})),
	multiple: false,
	params: {increase, cap: 20},
	filters: {},
});

const abilityIncreaseGroup = (abilities: Ability[]): ChooseGroup => ({
	key: 'origin-ability-increase',
	type: 'option',
	label: 'Повышение характеристик',
	options: [
		{
			key: 'plus-two-plus-one',
			label: '+2 к одной и +1 к другой',
			choose: [abilityGroup(abilities, 2), abilityGroup(abilities, 1)],
		},
		{
			key: 'plus-one-each',
			label: `+1 к каждой`,
			props: {abilityIncrease: Object.fromEntries(abilities.map((ability) => [ability, 1]))},
		},
	],
	multiple: false,
	params: {},
	filters: {},
});

const toolGroup = (toolChoice: OriginToolChoice): ChooseGroup => ({
	key: 'origin-tool',
	type: toolChoice,
	label: TOOL_CHOICE_LABELS[toolChoice],
	multiple: false,
	params: {},
	filters: toolChoice === 'tool' ? {artisan: true} : {},
});

const featGroup = (origin: OriginData): ChooseGroup => ({
	key: 'origin-feat',
	type: 'feat',
	label: 'Черта происхождения',
	options: origin.featId ? [{key: origin.featId}] : undefined,
	default: origin.featId,
	multiple: false,
	params: {variant: origin.featVariant},
	filters: origin.featCategory ? {featCategory: [origin.featCategory]} : {},
});
